import { Link } from "react-router-dom";
import { Mail, Phone, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-black border-t border-white/10 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div>
          <img
            src="https://customer-assets-m6fa6gv7.emergentagent.net/job_kpmx-service-portal/artifacts/kb72pc4y_1000238527.png"
            alt="KPMX"
            className="h-14 w-auto object-contain mb-4"
          />
          <p className="text-sm text-zinc-400 leading-relaxed">
            Motocross engine rebuilds, evo restorations and custom race builds. Trusted by
            collectors and VMXDN riders.
          </p>
        </div>
        <div>
          <h4 className="font-display uppercase tracking-widest text-white mb-4 text-sm">Services</h4>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li>Engine Rebuilds</li>
            <li>Custom Bike Builds</li>
            <li>Aftermarket Fitting</li>
            <li>Bearing Replacement</li>
            <li>New Bike Strip & Grease</li>
          </ul>
        </div>
        <div>
          <h4 className="font-display uppercase tracking-widest text-white mb-4 text-sm">Site</h4>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><Link to="/services" className="hover:text-orange-500">Services</Link></li>
            <li><Link to="/gallery" className="hover:text-orange-500">Gallery</Link></li>
            <li><Link to="/about" className="hover:text-orange-500">About</Link></li>
            <li><Link to="/book" className="hover:text-orange-500">Book Now</Link></li>
            <li><Link to="/admin/login" className="hover:text-orange-500" data-testid="footer-admin-link">Admin</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display uppercase tracking-widest text-white mb-4 text-sm">Contact</h4>
          <ul className="space-y-3 text-sm text-zinc-400">
            <li className="flex items-center gap-2"><Mail size={14} className="text-orange-500" /> kpmxracing@gmail.com</li>
            <li className="flex items-center gap-2"><Phone size={14} className="text-orange-500" /> 07453 909299</li>
            <li className="flex items-center gap-2"><Instagram size={14} className="text-orange-500" /> <a href="https://instagram.com/kpmxracing" target="_blank" rel="noopener noreferrer" className="hover:text-white">@kpmxracing</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-zinc-500 font-mono tracking-widest uppercase">
        © {new Date().getFullYear()} KPMX Motocross · Built for riders
      </div>
    </footer>
  );
}
